import React from 'react';

import { theme } from 'antd';

const { useToken } = theme;

const PlantIcon = ({ color, ...rest }: { color?: string; className?: string; [x: string]: unknown }) => {
  const { token } = useToken();
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        d="M11.9961 9.77813L13.0469 2.41172C13.0682 2.26249 13.1427 2.12599 13.2567 2.02736C13.3707 1.92873 13.5165 1.87462 13.6672 1.875H16.3328C16.4835 1.87462 16.6293 1.92873 16.7433 2.02736C16.8573 2.12599 16.9318 2.26249 16.9531 2.41172L16.875 10.625V16.875"
        stroke={color ?? token.colorText}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.125 10.625L8.125 6.875V10.625L3.125 6.875V16.875"
        stroke={color ?? token.colorText}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.875 16.875H18.125"
        stroke={color ?? token.colorText}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PlantIcon;
